import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NgxCaptchaModule } from 'ngx-captcha';

import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
// import { BodyComponent } from './body/body.component';
import { PostLoginRoutingModule } from '../post-login/post-login-routing.module';
import { PreLoginRoutingModule } from '../pre-login/pre-login-routing.module';

import { ScreenSizeDirective } from './directives/screen-size.directive';
import { SetContainerHeightDirective } from './directives/set-container-height.directive';
import { NewTagComponent } from './new-tag/new-tag.component';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DropdownForModalDirective } from '../post-login/directive/dropdown-for-modal.directive';
import { TimePickerComponent } from '../post-login/time-picker/time-picker.component';
import { BlockedCountriesPipe } from './Utils/blocked-countries.pipe';
import { ClickOutsideDirective } from './Utils/click-outside.directive';
import { CommonUtil } from './Utils/common-util';
import { ActionMenuComponent } from './action-menu/action-menu.component';
import { AjaxLoaderComponent } from './ajax-loader/ajax-loader.component';
import { BtnDynamicSmallComponent } from './btn-dynamic-small/btn-dynamic-small.component';
import { BtnDynamicComponent } from './btn-dynamic/btn-dynamic.component';
import { BtnFeatureToggleComponent } from './btn-feature-toggle/btn-feature-toggle.component';
import { BtnPrimaryBlackComponent } from './btn-primary-black/btn-primary-black.component';
import { BtnPrimaryBlueComponent } from './btn-primary-blue/btn-primary-blue.component';
import { BtnPrimaryGreyComponent } from './btn-primary-grey/btn-primary-grey.component';
import { BtnPrimaryWhiteComponent } from './btn-primary-white/btn-primary-white.component';
import { BtnToggleRoundComponent } from './btn-toggle-round/btn-toggle-round.component';
import { BtnToggleComponent } from './btn-toggle/btn-toggle.component';
import { CarouselComponent } from './carousel/carousel.component';
import { ChinaCaptchaComponent } from './china-captcha/china-captcha.component';
import { ConfirmationModalPopupComponent } from './confirmation-modal-popup/confirmation-modal-popup.component';
import { CustomBodyModalPopupComponent } from './custom-body-modal-popup/custom-body-modal-popup.component';
import { CustomizedHintComponent } from './customized-hint/customized-hint.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { AlphabetsOnlyDirective } from './directives/alphabets-only.directive';
import { DragDropDirective } from './directives/drag-drop.directive';
import { GetCountryIpDirective } from './directives/get-country-ip.directive';
import { TranslateDirective } from './directives/translate.directive';
import { DragDropFileComponent } from './drag-drop-file/drag-drop-file.component';
import { EquipmentQuestionComponent } from './equipment-question/equipment-question.component';
import { FacilityInfoConfirmationComponent } from './facility-info-confirmation/facility-info-confirmation.component';
import { FacilityInformationComponent } from './facility-information/facility-information.component';
import { GeneralQuestionComponent } from './general-question/general-question.component';
import { HaloDropdownComponent } from './halo-dropdown/halo-dropdown.component';
import { HaloTypeAheadDropdownComponent } from './halo-typeahead-dropdown/halo-typeahead-dropdown.component';
import { LanguageDropdownComponent } from './language-dropdown/language-dropdown.component';
import { OperatingHoursComponent } from './operating-hours/operating-hours.component';
import { PermissionButtonsComponent } from './permission-buttons/permission-buttons.component';
import { RecaptchaComponent } from './recaptcha/recaptcha.component';
import { RequestATechnicianVisitComponent } from './request-a-technician-visit/request-a-technician-visit.component';
import { StatsQuickFiltersComponent } from './stats-quick-filters/stats-quick-filters.component';
import { TextBtnComponent } from './text-btn/text-btn.component';
import { ToastComponent } from './toast/toast.component';
import { WarningModalPopupComponent } from './warning-modal-popup/warning-modal-popup.component';

import { ImageCropperModule } from 'ngx-image-cropper';
import { CustomPipesModule } from '../post-login/pipes/custom.pipe.module';
import { FileSizeUtil } from './Utils/fileSizeUtil';
import { BtnPrimaryRedComponent } from './btn-primary-red/btn-primary-red.component';
import { CustomizedCircleHintComponent } from './customized-circle-hint/customized-circle-hint.component';
import { FeatureAnyFlagsDirective } from './directives/feature-any-flags.directive';
import { FeatureFlagsDirective } from './directives/feature-flags.directive';
import { FeatureOffFlagsDirective } from './directives/feature-off-flags.directive';
import { HaloCustomLoaderComponent } from './halo-custom-loader/halo-custom-loader.component';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';
import { StatusLegendComponent } from './status-legend/status-legend.component';
import { StepperComponent } from './stepper/stepper.component';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SetContainerHeightDirective,
    ScreenSizeDirective,
    NewTagComponent,
    TranslateDirective,
    LanguageDropdownComponent,
    RecaptchaComponent,
    ChinaCaptchaComponent,
    WarningModalPopupComponent,
    TextBtnComponent,
    BtnPrimaryBlackComponent,
    BtnPrimaryBlueComponent,
    BtnPrimaryRedComponent,
    BtnPrimaryWhiteComponent,
    FacilityInformationComponent,
    ToastComponent,
    FacilityInfoConfirmationComponent,
    AjaxLoaderComponent,
    ConfirmationModalPopupComponent,
    CarouselComponent,
    GetCountryIpDirective,
    BtnPrimaryGreyComponent,
    AlphabetsOnlyDirective,
    HaloDropdownComponent,
    HaloTypeAheadDropdownComponent,
    GeneralQuestionComponent,
    RequestATechnicianVisitComponent,
    EquipmentQuestionComponent,
    ClickOutsideDirective,
    BtnToggleComponent,
    BtnDynamicComponent,
    DatepickerComponent,
    BtnDynamicSmallComponent,
    CustomBodyModalPopupComponent,
    BtnFeatureToggleComponent,
    CustomizedHintComponent,
    CustomizedCircleHintComponent,
    DropdownForModalDirective,
    TimePickerComponent,
    ActionMenuComponent,
    BlockedCountriesPipe,
    BtnToggleRoundComponent,
    PermissionButtonsComponent,
    OperatingHoursComponent,
    StatsQuickFiltersComponent,
    DateRangePickerComponent,
    DragDropFileComponent,
    DragDropDirective,
    StatusLegendComponent,
    FeatureFlagsDirective,
    FeatureOffFlagsDirective,
    FeatureAnyFlagsDirective,
    HaloCustomLoaderComponent,
    StepperComponent,
    ImageCropperComponent,
  ],
  imports: [
    CommonModule,
    PostLoginRoutingModule,
    PreLoginRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    CustomPipesModule,
    Ng2SearchPipeModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgbModule,
    ImageCropperModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    TranslateModule,
    RecaptchaComponent,
    TextBtnComponent,
    BtnPrimaryBlackComponent,
    BtnPrimaryBlueComponent,
    BtnPrimaryRedComponent,
    BtnPrimaryWhiteComponent,
    FacilityInformationComponent,
    ToastComponent,
    FacilityInfoConfirmationComponent,
    WarningModalPopupComponent,
    LanguageDropdownComponent,
    TranslateDirective,
    SetContainerHeightDirective,
    ScreenSizeDirective,
    NewTagComponent,
    AjaxLoaderComponent,
    ConfirmationModalPopupComponent,
    CarouselComponent,
    BtnPrimaryGreyComponent,
    HaloDropdownComponent,
    HaloTypeAheadDropdownComponent,
    GeneralQuestionComponent,
    RequestATechnicianVisitComponent,
    EquipmentQuestionComponent,
    BtnToggleComponent,
    BtnDynamicComponent,
    DatepickerComponent,
    BtnDynamicSmallComponent,
    CustomBodyModalPopupComponent,
    BtnFeatureToggleComponent,
    CustomizedHintComponent,
    CustomizedCircleHintComponent,
    DropdownForModalDirective,
    TimePickerComponent,
    ActionMenuComponent,
    BtnToggleRoundComponent,
    ClickOutsideDirective,
    PermissionButtonsComponent,
    OperatingHoursComponent,
    StatsQuickFiltersComponent,
    DateRangePickerComponent,
    DragDropFileComponent,
    DragDropDirective,
    StatusLegendComponent,
    FeatureFlagsDirective,
    FeatureOffFlagsDirective,
    FeatureAnyFlagsDirective,
    HaloCustomLoaderComponent,
    StepperComponent,
    ImageCropperComponent,
  ],
  providers: [CommonUtil, FileSizeUtil],
})
export class CoreModule {}
